import { useState } from "react";
import { describeFace, loadFaceRecognitionModels } from "../lib/faceRecognition";

// /anchor-admin — 锚点模板采集台(内部工具,不出现在任何导航里)
// 从图片 URL(需允许 CORS,如 Wikimedia)算出 128 维描述子;
// 默认只显示 JSON 供管理员在服务器侧提交,不在页面里要求管理密钥。
export default function AnchorAdmin() {
  const [imageUrl, setImageUrl] = useState("");
  const [status, setStatus] = useState("粘贴画像/照片的图片 URL(需支持 CORS,Wikimedia 可用)");
  const [descriptor, setDescriptor] = useState<number[] | null>(null);
  const [busy, setBusy] = useState(false);

  const compute = async () => {
    if (!imageUrl.trim()) return;
    setBusy(true);
    setDescriptor(null);
    setStatus("加载模型与图片…");
    try {
      await loadFaceRecognitionModels();
      const image = new Image();
      image.crossOrigin = "anonymous";
      await new Promise<void>((resolve, reject) => {
        image.onload = () => resolve();
        image.onerror = () => reject(new Error("图片加载失败(URL 或 CORS 问题)"));
        image.src = imageUrl.trim();
      });
      const result = await describeFace(image);
      if (!result) throw new Error("没有在图中找到清晰正脸");
      setDescriptor(result);
      setStatus("已生成 128 维描述子 ✓");
    } catch (error) {
      setStatus(error instanceof Error ? error.message : "计算失败");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="face3-page" style={{ maxWidth: 720, margin: "0 auto", padding: "40px 20px" }}>
      <h1 style={{ fontSize: 22 }}>Anchor 模板采集台</h1>
      <p style={{ color: "#8399a6", fontSize: 12 }}>{status}</p>
      <input
        value={imageUrl}
        onChange={(event) => setImageUrl(event.target.value)}
        placeholder="https://upload.wikimedia.org/…jpg"
        style={{ width: "100%", padding: "12px", borderRadius: 10, border: "1px solid rgba(255,255,255,.2)", background: "rgba(255,255,255,.05)", color: "white", fontSize: 12 }}
      />
      <button
        type="button"
        onClick={compute}
        disabled={busy}
        style={{ marginTop: 12, padding: "12px 22px", borderRadius: 10, border: 0, fontWeight: 800, cursor: "pointer" }}
      >
        {busy ? "计算中…" : "计算描述子"}
      </button>
      {imageUrl.trim() && (
        <div style={{ marginTop: 16 }}>
          {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
          <img src={imageUrl.trim()} alt="预览图片" crossOrigin="anonymous" style={{ maxWidth: 260, borderRadius: 12 }} />
        </div>
      )}
      {descriptor && (
        <textarea
          readOnly
          id="descriptor-json"
          value={JSON.stringify(descriptor)}
          style={{ width: "100%", height: 160, marginTop: 16, padding: 12, borderRadius: 10, background: "rgba(0,0,0,.4)", color: "#9fe8d9", fontSize: 10 }}
        />
      )}
    </main>
  );
}
